import React, { useEffect, useState } from 'react';
import { Button, Col, FormControl, FormLabel, Row } from 'react-bootstrap';
import LoadingSpinner from '../../../components/LoadinSpinner';
import TitlePage from '../../../components/TitlePage';
import InputGeral from '../../../components/InputGeral/Index';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import SubmitForm from '../../../components/SubmitForm';
import SelectDinamico from '../../../components/SelectDinamico';

import ResponsiveDataTable from '../../../components/DataTable';
import { CancelarButton } from '../../../components/SubmitForm/styles';
import ConsultaCentroCusto from '../../../../lib/json/consultas/CentroCustoSSMA.json'
import ConsultaDescricaoAtividade from '../../../../lib/json/consultas/DescricaoAtividade.json'
import ConsultaLocalAtividade from '../../../../lib/json/consultas/LocalAtividade.json'
import ConsultaRegistroDesvios from '../../../../lib/json/consultas/RegistroDesvios.json'
import ConsultaTipoInspecao from '../../../../lib/json/consultas/TipoInspecao.json'
import ConsultaEmpresasFilial from '../../../../lib/json/consultas/EmpresasFilial.json'
import ConsultaConfiguracaoEmail from '../../../../lib/json/consultas/ConfiguracaoEmail.json'

import ConsultaGiroSSMA from '../../../../lib/json/consultas/GiroSSMA.json'
import ConsultaGiroSSMAItens from '../../../../lib/json/consultas/GiroSSMA-Itens.json'
import ConsultaGiroSSMAParticipantes from '../../../../lib/json/consultas/GiroSSMA-Participantes.json'

import { format, parse } from 'date-fns';
import { ConsultaAPI } from '../../../../backend/ConsultaAPI';
import { HRDivider } from './styles';
import { ConsumoAPI_FileUpload, ConsumoAPI_POST, ConsumoAPI_PUT } from '../../../../backend/ConsumoAPI';
import { RetornaUsuarioLogado, SucessoMsg, formatDateComponent } from '../../../contents/VariaveisGlobais';
import DisparaEmail from '../../../../backend/DisparaEmail';
import UploadFiles from '../../../components/UploadFiles';
import { usePopUp } from '../../../components/BootBox';

function FichaGiroSSMA(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    
    var [carregar, setCarregar] = useState(false);
    var [inclusao, setInclusao] = useState(true);

    const usuarioLogado = RetornaUsuarioLogado();

    const isFormVisual = window.location.href.includes('Visualizar');
    const { idGiroSSMA } = useParams();

    const [disabledForm, setDisabledForm] = useState(isFormVisual);
    const [habilitaAvaliacao, setHabilitaAvaliacao] = useState(false);
    const [campoFilial, setCampoFilial] = useState({value: '', label: "Digite"});
    const [campoEmissao, setCampoEmissao] = useState(format(Date.now(), "yyyy-MM-dd"));
    const [campoTipoInspecao, setCampoTipoInspecao] = useState({value: '', label: "Digite"});
    const [campoCentroCusto, setCampoCentroCusto] = useState({value: '', label: "Digite"});
    const [consultaCentroCusto, setConsultaCentroCusto] = useState('');
    const [campoFile, setCampoFile] = useState([]);
    const [tipoStatus, setTipoStatus] = useState('Elaboração');

    // Consulta do grid
    var consultaGiro  = ConsultaGiroSSMA.consulta + (idGiroSSMA ? ` WHERE PSMA.Id = '${idGiroSSMA}'` : '');
    var consultaParticipantes  = ConsultaGiroSSMAParticipantes.consulta + (idGiroSSMA ? ` WHERE PatrulhaSSMAId = '${idGiroSSMA}'` : '');
    var consultaItens  = ConsultaGiroSSMAItens.consulta + (idGiroSSMA ? ` WHERE PatrulhaSSMAId = '${idGiroSSMA}'` : '');

    // Processa consulta do grid
    const loadGiroSSMA = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaAPI( consultaGiro );
        
        if (retConsulta.data){
            const EmpresaFilial = retConsulta.data[0].Filial.split(' - ')
            const CentroCusto = retConsulta.data[0].CentroCusto.split(' - ')[0];
            const DataEmissao = formatDateComponent(retConsulta.data[0].DataHora)
            const TipoInspecao = retConsulta.data[0].TipoInspecao.split(' - ')[0]
            const Filial = EmpresaFilial[0]
            const Anexos = retConsulta.data[0].Anexos || ''
            const Status = retConsulta.data[0].Status === 'undefined' ? 'Elaboração' : ( retConsulta.data[0].Status || tipoStatus )

            const parametroEmpresa = usuarioLogado.parametrosEmpresas.filter( (empresa) => empresa.empresaFilial.substr(0,4) === Filial )
            let filtraCentroCusto = ''

            if (parametroEmpresa.length > 0 ){
                if (parametroEmpresa[0].centroCusto.length > 0){
                    filtraCentroCusto += " AND CTT_CUSTO IN ('" + parametroEmpresa[0].centroCusto.join("','") + "')"
                }

                if (parametroEmpresa[0].avaliarSSMA && Status === 'Aguardando' && !isFormVisual){
                    setDisabledForm(true)
                    setHabilitaAvaliacao(true)
                }
            }

            if (Status.includes('Concluído','Concluído com Ressalvas')){
                setDisabledForm(true)
                setHabilitaAvaliacao(true)
            }

            const consultaCC = ConsultaCentroCusto.consulta + " WHERE CTT_FILIAL = '" + Filial + "' " + filtraCentroCusto
            setConsultaCentroCusto(consultaCC)
            
            if (Anexos){
                setCampoFile( JSON.parse(Anexos) )
            }

            setTipoStatus(Status)
            setCampoFilial( { value: Filial, label: retConsulta.data[0].Filial} );
            setCampoEmissao( DataEmissao );
            setCampoCentroCusto( { value: CentroCusto, label: retConsulta.data[0].CentroCusto} );
            setCampoTipoInspecao( { value: TipoInspecao, label: retConsulta.data[0].TipoInspecao} );
        }
        
        var retConsultaParticipante = await ConsultaAPI( consultaParticipantes );
        
        if (retConsultaParticipante.data){
            const aParticipantes = retConsultaParticipante.data.map( (item) => {
                return ({ Id: item.Id, Nome: item.Nome, Cargo: item.Cargo, Email: item.Email, PatrulhaSSMA: item.Id, deletado: false })
            })

            setDataParticipantes(aParticipantes);
        }

        var retConsultaItens = await ConsultaAPI( consultaItens );
        
        if (retConsultaItens.data){
            const aItens = retConsultaItens.data.map( (item) => {
                let dataConclusaoUSA = ''
                let dataConclusaoBR = ''

                const parsedPrazoCorrecao = parse(item.PrazoCorrecao, 'dd/MM/yyyy', new Date());
                const parsedDataConclusao = parse(item.DataConclusao, 'dd/MM/yyyy', new Date());
                const status = item.Status === 'undefined' ? 'Elaboração' : ( item.Status || tipoStatus )

                if (format(parsedDataConclusao, 'yyyy-MM-dd') !== '1900-01-01'){
                    dataConclusaoUSA = format(parsedDataConclusao, 'yyyy-MM-dd')
                    dataConclusaoBR = format(parsedDataConclusao, 'dd/MM/yyyy')
                }
                return ({
                    Id: item.Id, 
                    descricao: { value: item.DescricaoAtividadeId, label: item.DescricaoAtividadeId + ' - ' + item.DescricaoAtividadeNome}, 
                    local: { value: item.LocalAtividadeId, label: item.LocalAtividadeId + ' - ' + item.LocalAtividadeNome}, 
                    desvio: { value: item.desvioId, label: item.desvioId + ' - ' + item.DesvioNome}, 
                    prazo: { value: format(parsedPrazoCorrecao, 'yyyy-MM-dd'), label: format(parsedPrazoCorrecao, 'dd/MM/yyyy')},
                    conclusao: { value: dataConclusaoUSA, label: dataConclusaoBR},
                    responsavel: item.Responsavel,
                    verificado: item.VerificadoPor,
                    status: status,
                    motivo: item.MotivoRejeicao,
                    correcao: item.CorrecaoProposta, 
                    PatrulhaSSMA: item.Id,
                    deletado: false
            })})

            setDataItem(aItens);
        }

        setCarregar(false);
    }

    const handleCampoFilial = (e) =>{
        const parametroEmpresa = usuarioLogado.parametrosEmpresas.filter( (empresa) => empresa.empresaFilial.substr(0,4) === e.value )
        let filtraCentroCusto = ''

        if (parametroEmpresa.length > 0 ){
            if (parametroEmpresa[0].centroCusto.length > 0){
                filtraCentroCusto += " AND CTT_CUSTO IN ('" + parametroEmpresa[0].centroCusto.join("','") + "')"
            }
        }

        const consultaCC = ConsultaCentroCusto.consulta + " WHERE CTT_FILIAL = '" + e.value + "' " + filtraCentroCusto
        setConsultaCentroCusto(consultaCC)
        
        setCampoFilial(e)
        setCampoCentroCusto( { value: '', label: 'Digite'} );
        
    }

    const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];
        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data;
            const filesUpload = [...campoFile, ...newFiles]
            setCampoFile(filesUpload)
            
            return filesUpload
        }
    }

    const handleDelFiles = (fileDelete) => {
        const updatedFiles = [...campoFile];
        updatedFiles.splice(fileDelete, 1);
        
        setCampoFile(updatedFiles)
        return updatedFiles;
    }
    
    const [dataParticipantes, setDataParticipantes] = useState([]);
    const [dataGridParticipantes, setDataGridParticipantes] = useState([]);
    const [campoIdParticipante, setCampoIdParticipante] = useState();
    const [campoNomeParticipante, setCampoNomeParticipante] = useState('');
    const [campoCargoParticipante, setCampoCargoParticipante] = useState('');
    const [campoEmailParticipante, setCampoEmailParticipante] = useState('');
    const columnsParticipante = [
        {
            Header: 'Nome',
            accessor: 'Nome',
        },
        {
            Header: 'Cargo',
            accessor: 'Cargo',
        },
        {
            Header: 'E-mail',
            accessor: 'Email',
        }
    ];

    const btnIncluirParticipante = () => {
        if (!campoNomeParticipante){
            toast.warning('O prenchimento do campos Nome é obrigatório.');
            return;
        }
        if (!campoCargoParticipante){
            toast.warning('O prenchimento do campo Cargo é obrigatório.');
            return;
        }
        if (!campoEmailParticipante){
            toast.warning('O prenchimento do campo Email é obrigatório.');
            return;
        }

        if (campoIdParticipante){
            const id = campoIdParticipante
            
            setDataParticipantes((prevData) => 
                prevData.map((participante) => {
                    if (participante.Id === id){
                        return { ...participante, Nome: campoNomeParticipante, Cargo: campoCargoParticipante, Email: campoEmailParticipante, deletado: false };
                    }else{
                        return participante;
                    } 
                })
            );

            setCampoIdParticipante('')
        }else{
            const newId = Date.now()
            setDataParticipantes((prevData) => [...prevData, { Id: newId, Nome: campoNomeParticipante, Cargo: campoCargoParticipante, Email: campoEmailParticipante, PatrulhaSSMA: "", deletado: false },]);
        }

        btnCancelarParticipante()
    };

    const handleAlterarParticipante = (row) => {
        setCampoIdParticipante( row.original.Id )
        setCampoNomeParticipante( row.values.Nome )
        setCampoCargoParticipante( row.values.Cargo )
        setCampoEmailParticipante( row.values.Email )
    };

    const btnCancelarParticipante = () => {
        setCampoIdParticipante('')
        setCampoNomeParticipante('')
        setCampoCargoParticipante('')
        setCampoEmailParticipante('')
    }

    const handleExcluirParticipante = (row) => {
        const id = row.original.Id;
        
        setDataParticipantes((prevData) => 
            prevData.map((participante) => {
                if (participante.Id === id){
                    return { ...participante, deletado: true };
                }else{
                    return participante;
                } 
            })
        );
        
    };

    const [dataItem, setDataItem] = useState([]);
    const [dataGridItem, setDataGridItem] = useState([]);
    const [campoIdItem, setCampoIdItem] = useState();
    const [campoDescricaoItem, setCampoDescricaoItem] = useState({value: '', label: 'Digite' });
    const [campoLocalItem, setCampoLocalItem] = useState({value: '', label: 'Digite' });
    const [campoDesvioItem, setCampoDesvioItem] = useState({value: '', label: 'Digite' });
    const [campoPrazoItem, setCampoPrazoItem] = useState();
    const [campoResponsavelItem, setCampoResponsavelItem] = useState();
    const [campoCorrecaoItem, setCampoCorrecaoItem] = useState();
    
    var campoMotivoGiro = '';
    var campoDataVerificado = '';
    var campoVerificado = '';
    
    const columnsItem = [
        {
            Header: 'Descrição da Atividade',
            accessor: 'descricao.label',
        },
        {
            Header: 'Local da Atividade',
            accessor: 'local.label',
        },
        {
            Header: 'Desvio',
            accessor: 'desvio.label',
        },
        {
            Header: 'Prazo p/ Correção',
            accessor: "prazo.label",
        },
        {
            Header: 'Responsável Ação/Assinatura',
            accessor: 'responsavel',
        },
        {
            Header: 'Data Verificação',
            accessor: "conclusao.label",
        },
        {
            Header: 'Verificado por',
            accessor: 'verificado',
        },
        {
            Header: 'Status',
            accessor: 'status',
        }
    ];

    const btnIncluirItem = () => {
        if (!campoDescricaoItem.value){
            toast.warning('O prenchimento do campo Descricao da Atividade é obrigatório.');
            return;
        }
        if (!campoLocalItem.value){
            toast.warning('O prenchimento do campo Local da Atividade é obrigatório.');
            return;
        }
        if (!campoDesvioItem.value){
            toast.warning('O prenchimento do campo Desvios é obrigatório.');
            return;
        }
        if (!campoPrazoItem){
            toast.warning('O prenchimento do campo Prazo da Correção é obrigatório.');
            return;
        }
        if (!campoResponsavelItem){
            toast.warning('O prenchimento do campo Responsavel da Ação é obrigatório.');
            return;
        }
        if (!campoCorrecaoItem){
            toast.warning('O prenchimento do campo Correcao Proposta é obrigatório.');
            return;
        }
        
        const parsedPrazoCorrecao = parse(campoPrazoItem, 'yyyy-MM-dd', new Date()) //Tratativa, para ao converter não perder 1 Dia
        const formatPrazoCorrecao = format(parsedPrazoCorrecao, "dd/MM/yyyy")

        if (campoIdItem){
            const id = campoIdItem
            
            setDataItem((prevData) => {
                return prevData.map((item) => {
                    if (item.Id === id){
                        return { ...item, 
                                descricao: campoDescricaoItem, 
                                local: campoLocalItem, 
                                desvio: campoDesvioItem,
                                prazo: { value: campoPrazoItem, label: formatPrazoCorrecao},
                                conclusao: { value: '', label: '' },
                                responsavel: campoResponsavelItem,
                                verificado: '',
                                status: 'Elaboração',
                                motivo: '',
                                correcao: campoCorrecaoItem,
                                deletado: false
                         };
                    }else{
                        return item;
                    } 
                })
            });

            setCampoIdItem('')
        }else{
            const newId = Date.now()
                
            setDataItem((prevData) => [...prevData, { 
                Id: newId, 
                descricao: campoDescricaoItem, 
                local: campoLocalItem, 
                desvio: campoDesvioItem,
                prazo: { value: campoPrazoItem, label: formatPrazoCorrecao},
                conclusao: { value: '', label: '' },
                responsavel: campoResponsavelItem,
                verificado: '',
                status: 'Elaboração',
                motivo: '',
                correcao: campoCorrecaoItem, 
                PatrulhaSSMA: "",
                deletado: false
            },]);
        }

        btnCancelarItem()
    };

    const btnCancelarItem = () => {
        setCampoIdItem('')
        setCampoDescricaoItem( {value: '', label: 'Digite' } )
        setCampoLocalItem( {value: '', label: 'Digite' } )
        setCampoDesvioItem( {value: '', label: 'Digite' } )
        setCampoPrazoItem( '' )
        setCampoResponsavelItem( '' )
        setCampoCorrecaoItem( '' )
    }
    
    const handleShowCorrecao = (row) =>{
        const buttonsRender = [
            { variant: 'secondary', action: FechaBootBox, label: 'Fechar' }
        ]
        
        DisparaBootBox('Correção Proposta: ', row.original.correcao, buttonsRender, null, null)
    }

    const handleShowMotivo = (row) =>{
        const buttonsRender = [
            { variant: 'secondary', action: FechaBootBox, label: 'Fechar' }
        ]
        
        DisparaBootBox('Motivo Rejeição: ', row.original.motivo, buttonsRender, null, null)
    }
    
    const handleAlterarItem = (row) => {
        setCampoIdItem( row.original.Id )
        setCampoDescricaoItem( { value: row.original.descricao.value, label: row.original.descricao.label } )
        setCampoLocalItem( { value: row.original.local.value, label: row.original.local.label } )
        setCampoDesvioItem( { value: row.original.desvio.value, label: row.original.desvio.label } )
        setCampoPrazoItem( row.original.prazo.value )
        setCampoResponsavelItem( row.values.responsavel )
        setCampoCorrecaoItem( row.original.correcao )
    };

    const handleExcluirItem = (row) => {
        const id = row.original.Id;

        setDataItem((prevData) => 
            prevData.map((item) => {
                if (item.Id === id){
                    return { ...item, deletado: true };
                }else{
                    return item;
                } 
            })
        );
        
    };

    const handleAprovaReprova = async(id, Status) => {
        const dataConclusao = parse(campoDataVerificado, 'yyyy-MM-dd', new Date()) //Tratativa, para ao converter não perder 1 Dia
        const formatDataConclusao = format(dataConclusao, "dd/MM/yyyy")

        await setDataItem((prevData) => {
            return prevData.map((item) => {
                if (item.Id === id){
                    return { ...item, 
                            descricao: item.descricao, 
                            local: item.local, 
                            desvio: item.desvio,
                            prazo: item.prazo,
                            conclusao: { value: dataConclusao, label: formatDataConclusao },
                            responsavel: item.responsavel,
                            verificado: usuarioLogado.nome,
                            status: Status,
                            motivo: campoMotivoGiro,
                            correcao: item.correcao,
                            deletado: false
                        };
                }else{
                    return item;
                } 
            })
        });

        const aStatus = dataItem.map((item) => {
            if (item.Id !== id){
                return item.status
            }else{
                return Status   
            }
        
        })
        
        const statusAguardando = aStatus.filter(item => item === 'Aguardando' || item === 'Elaboração').length
        const statusRejeitado = aStatus.filter(item => item === 'Rejeitado').length
        const statusPatrulha = statusAguardando > 0 ? 'Aguardando' : statusRejeitado > 0 ? 'Concluído com Ressalvas' : 'Concluído'
        
        const valueJSON = JSON.parse(`{ "Status": "${Status}", "VerificadoPor" : "${campoVerificado}", "MotivoRejeicao": "${campoMotivoGiro}", "DataConclusao": "${dataConclusao}", "IdPatrulha" : "${idGiroSSMA}", "StatusPatrulha": "${statusPatrulha}" }`)
        
        const rota = 'giroSSMA/itemPatrulha/' + id;
        let retConsumo = await ConsumoAPI_PUT(rota, valueJSON)

        setTipoStatus(statusPatrulha)

        if (statusPatrulha.includes('Concluído','Concluído com Ressalvas')){
            setDisabledForm(true)
            setHabilitaAvaliacao(true)
        }
    }

    const handleAprovarItem = async(row) => {
        const idRow = row.original.Id;
        const Mensagem = ( <>
                <FormLabel>Data Verificado</FormLabel>
                <FormControl
                    type="date"
                    onChange={handleCampoDataVerificado}
                />
                <br/>
                <FormLabel>Verificado Por</FormLabel>
                <FormControl
                    type='text'
                    onChange={handleCampoVerificado}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaAprovacao, label: 'Confirmar' },
            { variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
        ]
        
        campoMotivoGiro = ''
        campoDataVerificado = ''
        campoVerificado = ''

        DisparaBootBox('Confirma Aprovação ?', Mensagem, buttonsRender, idRow, null)
    }

    const handleCampoMotivo = (e) =>{
        campoMotivoGiro = e.target.value
    }

    const handleCampoDataVerificado = (e) =>{
        campoDataVerificado = e.target.value
    }

    const handleCampoVerificado = (e) =>{
        campoVerificado = e.target.value
    }
    
    const handleReprovarItem = (row) => {
        const idRow = row.original.Id;
        const Mensagem = ( <>
                <FormLabel>Data Verificado</FormLabel>
                <FormControl
                    type='date'
                    onChange={handleCampoDataVerificado}
                />
                <br/>
                <FormLabel>Verificado Por</FormLabel>
                <FormControl
                    type='text'
                    onChange={handleCampoVerificado}
                />
                <br/>
                <FormLabel>Motivo Rejeição</FormLabel>
                <FormControl
                    type='text'
                    onChange={handleCampoMotivo}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaRejeicao, label: 'Confirmar' },
            { variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
        ]
        
        campoMotivoGiro = ''
        campoDataVerificado = ''
        campoVerificado = ''

        DisparaBootBox('Confirma Rejeição ?', Mensagem, buttonsRender, idRow, null)
    }

    const handleConfirmaAprovacao = async(id) => {
        if (!campoDataVerificado){
            toast.warning('O prenchimento da Data de Verificação é obrigatório.');
            return
        }
        if (!campoVerificado){
            toast.warning('O prenchimento do Verificado Por é obrigatório.');
            return
        }

        FechaBootBox()
        handleAprovaReprova( id, 'Concluído');
    }

    const handleConfirmaRejeicao = async(id) => {
        if (!campoDataVerificado){
            toast.warning('O prenchimento da Data de Verificação é obrigatório.');
            return
        }
        if (!campoVerificado){
            toast.warning('O prenchimento do Verificado Por é obrigatório.');
            return
        }
        if (!campoMotivoGiro){
            toast.warning('O prenchimento do Motivo da Rejeição é obrigatório.');
            return
        }

        FechaBootBox()
        handleAprovaReprova( id, 'Rejeitado' );
    }

    const buttonsCorrecao = {isVisual: true, action: handleShowCorrecao, label: "Correção Proposta", icone: "BiMessageRoundedDetail", style: "light", regraExclude: "(!row.original.correcao)"}
    const buttonsObservacao = {isVisual: true, action: handleShowMotivo, label: "Motivo Rejeição", icone: "BiMessageRoundedX", style: "danger", regraExclude: "(!row.original.motivo)"}

    const handleEnviar = async() =>{
        handleSalvar('Aguardando')
    }

    const handleSalvarConfeccao = async() =>{
        handleSalvar('Elaboração')
    }

    const handleSalvar = async(statusAux) =>{
        if (!campoFilial.value){
            toast.warning('O prenchimento do campo Filial é obrigatório.');
            return;
        }
        
        if (!campoEmissao){
            toast.warning('O prenchimento do campo Emissão é obrigatório.');
            return;
        }

        if (!campoTipoInspecao.value){
            toast.warning('O prenchimento do campo Tipo de Inspeção é obrigatório.');
            return;
        }

        if (!campoCentroCusto.value){
            toast.warning('O prenchimento do campo Centro de Custo é obrigatório.');
            return;
        }

        try {
            const JsonParticipantes =  JSON.stringify(dataParticipantes)
            const JsonItens =  JSON.stringify(dataItem)
            const JsonAnexos = campoFile ? JSON.stringify(campoFile, null, 2) : "{}";
            const horaAtual = format(new Date(), "HH:mm:ss");
            
            const valueJSON = JSON.parse(`{ "Filial": "${campoFilial.value}", 
                                            "DataEmissao": "${format(campoEmissao + ' ' + horaAtual, "yyyy-MM-dd HH:mm:ss")}", 
                                            "CentroCustoId": "${campoCentroCusto.value}",
                                            "Descricao": "${campoCentroCusto.label.split(' - ')[1]}", 
                                            "Status": "${statusAux}",
                                            "TipoInspecao": "${campoTipoInspecao.value}", 
                                            "Anexos": ${JsonAnexos}, 
                                            "Participantes": ${JsonParticipantes}, 
                                            "Itens": ${JsonItens} }`);
            setCarregar(true);

            const rota = 'giroSSMA' + (inclusao ? '' : '/' + idGiroSSMA);
            let retConsumo = await (inclusao
                ? ConsumoAPI_POST(rota, valueJSON)
                : ConsumoAPI_PUT(rota, valueJSON));
    
            SucessoMsg(retConsumo.description);
            
            if (inclusao){
                const urlAcesso = window._env_?.REACT_APP_URL + '/ssma/GiroSSMA/Visualizar/' + retConsumo.content
                
                var retUsuarios = await ConsultaAPI( ConsultaConfiguracaoEmail.consulta + " WHERE CentroCustoId = '" + campoCentroCusto.value + "'" );
        
                if (retUsuarios.data && retUsuarios.data.length > 0){
                    retUsuarios.map((usuario) => {
                        DisparaEmail({
                            destinatario: usuario.Email,
                            assunto: 'Novo Giro de SSMA - Tools System',
                            corpo: `<p>Prezado(a) ${usuario.Nome}</p></br>
                                    <p>Esperamos que esta mensagem o encontre bem. Gostaríamos de informar sobre o novo cadastro do "Giro de SSMA" incluído em nosso sistema. </p></br>
                                    <h3>Detalhes da Inclusão:</h3>
                                    <p><strong>Filial:</strong> ${campoFilial.label}</p>
                                    <p><strong>Centro de Custo:</strong> ${campoCentroCusto.label}</p>
                                    <p><strong>Tipo de Inspeção:</strong> ${campoTipoInspecao.label}</p>
                                    <a href='${urlAcesso}'>Mais detalhes clique no link</a></br></br>
                                    <p><span>Agradecemos por seu comprometimento com a segurança, saúde e sustentabilidade!</span></p>`
                        });
                    })
                }
            }

        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    useEffect(() => {
        if (idGiroSSMA){
            if (!disabledForm){
                setInclusao(false)
            }
            loadGiroSSMA();
        }

        const consultaCC = ConsultaCentroCusto.consulta + " WHERE CTT_FILIAL = 'XXXXXX' "
        setConsultaCentroCusto(consultaCC)
    }, []);

    useEffect(() => {
        setDataGridParticipantes(dataParticipantes.filter((participante) => !participante.deletado));
    }, [dataParticipantes]);

    useEffect(() => {
        setDataGridItem(dataItem.filter((item) => !item.deletado));
    }, [dataItem]);
    
    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Giro SSMA"/>
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Emissão"
                        key="Emissão"
                        tipo='date'
                        value={campoEmissao}  // Use detail.cargo instead of campoEmail
                        onChange={(e) => { setCampoEmissao(e.target.value)}}
                        disabled={disabledForm}
                    />
                </Col>
                <Col md="3" xs="12">
                    <SelectDinamico 
                        label="Filial"
                        consulta={ConsultaEmpresasFilial.consulta + " WHERE '01' + LEFT(Filial, 2) IN ('" + usuarioLogado.empresasUsuario.join("','") + "') GROUP BY LEFT(Filial, 2), LEFT(Filial, 4), Empresa ORDER BY LEFT(Filial, 4)"}
                        tabela={ConsultaEmpresasFilial.tabelas}
                        cValue="Filial"
                        cText='Filial + " - " + item.Empresa'
                        isMultiplo={false}
                        campoValue={campoFilial}
                        value={campoFilial}
                        onchange={(e) => handleCampoFilial(e)}
                        showNoFilter={true}
                        disabled={disabledForm}
                    />
                </Col>
                <Col md="3" xs="12">
                    <SelectDinamico 
                        label="Centro de Custo"
                        consulta={consultaCentroCusto}
                        tabela={ConsultaCentroCusto.tabelas}
                        cValue="CTT_CUSTO"
                        cText='CTT_CUSTO + " - " + item.CTT_DESC01'
                        isMultiplo={false}
                        campoValue={campoCentroCusto}
                        value={campoCentroCusto}
                        showNoFilter={true}
                        onchange={(e) => setCampoCentroCusto(e)}
                        disabled={disabledForm}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectDinamico 
                        label="Tipo Inspeção"
                        consulta={ConsultaTipoInspecao.consulta}
                        tabela={ConsultaTipoInspecao.tabelas}
                        cValue="Id"
                        cText='Id + " - " + item.Nome'
                        isMultiplo={false}
                        campoValue={campoTipoInspecao}
                        value={campoTipoInspecao}
                        onchange={(e) => setCampoTipoInspecao(e)}
                        showNoFilter={true}
                        disabled={disabledForm}
                    />
                </Col>
                <Col md="12" xs="12">
                    <UploadFiles 
                        onDropEvent={handleAddFiles}
                        onDeleteEvent={handleDelFiles}
                        value={campoFile}
                        disabled={disabledForm} 
                    />
                </Col>
            </Row>
            <HRDivider></HRDivider>
            <Row>
                <Col md="10" xs="12">
                    <h5>Participantes: </h5>
                </Col>
            </Row>
            <Row>
                <Col md="4" xs="12">
                    <InputGeral
                        label="Nome"
                        tipo='text'
                        value={campoNomeParticipante}  // Use detail.nome instead of campoNome
                        onChange={(e) => setCampoNomeParticipante(e.target.value)}
                        disabled={disabledForm}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Cargo/Função"
                        key="Cargo"
                        tipo='text'
                        value={campoCargoParticipante}  // Use detail.cargo instead of campoEmail
                        onChange={(e) => setCampoCargoParticipante(e.target.value)}
                        disabled={disabledForm}
                    />
                </Col>
                <Col md={ campoIdParticipante && "3" || "4" } xs="12">
                    <InputGeral
                        label="Email"
                        fieldName="Email"
                        tipo='email'
                        value={campoEmailParticipante}  // Use detail.email instead of campoEmail
                        onChange={(e) => setCampoEmailParticipante(e.target.value)}
                        disabled={disabledForm}
                    />
                </Col>
                { !disabledForm && (
                    <Col md={ campoIdParticipante && "2" || "1" } xs="12" className="d-flex align-content-end align-items-end justify-content-end">
                        <Button variant="primary" onClick={btnIncluirParticipante}>
                            { campoIdParticipante && "✓ Salvar" || "✚ Adicionar" }
                        </Button>
                        { campoIdParticipante && (
                            <CancelarButton variant="warning" onClick={btnCancelarParticipante}>
                                ✗ Cancelar
                            </CancelarButton>
                        )}
                    </Col>
                )}
            </Row>
            {dataParticipantes && (
                <ResponsiveDataTable 
                    habilitaBuscar={false}  
                    columns={columnsParticipante} 
                    data={dataGridParticipantes} 
                    buttons= { disabledForm ? [] : [
                            {action: handleAlterarParticipante, label: "Alterar", icone: "MdOutlineEditNote"}, 
                            {action: handleExcluirParticipante, label: "Excluir", icone: "MdPlaylistRemove", style: "danger"}
                    ]}
                />
            )}
            
            <HRDivider></HRDivider>
            <Row>
                <Col md="10" xs="12">
                    <h5>Item da Inspeção: </h5>
                </Col>
            </Row>
            <Row>
                <Col md="6" xs="12">
                    <SelectDinamico 
                        label="Descrição da Atividade"
                        consulta={ConsultaDescricaoAtividade.consulta}
                        tabela={ConsultaDescricaoAtividade.tabelas}
                        cValue="Id"
                        cText='Id + " - " + item.Nome'
                        isMultiplo={false}
                        value={campoDescricaoItem}
                        campoValue={campoDescricaoItem}
                        onchange={(e) => setCampoDescricaoItem(e)}
                        disabled={disabledForm}
                        showNoFilter={true}
                    />
                </Col>
                <Col md="6" xs="12">
                    <SelectDinamico 
                        label="Local da Atividade"
                        consulta={ConsultaLocalAtividade.consulta}
                        tabela={ConsultaLocalAtividade.tabelas}
                        cValue="Id"
                        cText='Id + " - " + item.Nome'
                        isMultiplo={false}
                        value={campoLocalItem}
                        campoValue={campoLocalItem}
                        onchange={(e) => setCampoLocalItem(e)}
                        disabled={disabledForm}
                        showNoFilter={true}
                    />      
                </Col>
                <Col md="5" xs="12">
                    <SelectDinamico 
                        label="Desvios"
                        consulta={ConsultaRegistroDesvios.consulta}
                        tabela={ConsultaRegistroDesvios.tabelas}
                        cValue="Id"
                        cText='Id + " - " + item.Nome'
                        isMultiplo={false}
                        value={campoDesvioItem}
                        campoValue={campoDesvioItem}
                        onchange={(e) => setCampoDesvioItem(e)}
                        disabled={disabledForm}
                        showNoFilter={true}
                    /> 
                </Col>
                <Col md="2" xs="12">
                    <InputGeral
                        label="Prazo Correção"
                        key="Cargo"
                        tipo='date'
                        value={campoPrazoItem}  // Use detail.cargo instead of campoEmail
                        onChange={(e) => setCampoPrazoItem(e.target.value)}
                        disabled={disabledForm}
                    />
                </Col>
                <Col md="5" xs="12">
                    <InputGeral
                        label="Responsável da Ação"
                        tipo='text'
                        value={campoResponsavelItem}  // Use detail.nome instead of campoNome
                        onChange={(e) => setCampoResponsavelItem(e.target.value)}
                        disabled={disabledForm}
                    />
                </Col>
                <Col md={ campoIdItem && "10" || disabledForm && '12' || "11" } xs="12">
                    <InputGeral
                        label="Correção Proposta"
                        fieldName="Email"
                        tipo='text'
                        value={campoCorrecaoItem}  // Use detail.email instead of campoEmail
                        onChange={(e) => setCampoCorrecaoItem(e.target.value)}
                        disabled={disabledForm}
                    />
                </Col>
                { !disabledForm && (
                    <Col md={ campoIdItem && "2" || "1" } xs="12" className="d-flex align-content-end align-items-end justify-content-end">
                        <Button variant="primary" onClick={btnIncluirItem}>
                            { campoIdItem && "✓ Salvar" || "✚ Adicionar" }
                        </Button>
                        { campoIdItem && (
                            <CancelarButton variant="warning" onClick={btnCancelarItem}>
                                ✗ Cancelar
                            </CancelarButton>
                        )}
                    </Col>
                )}
            </Row>
            {dataItem && (
                <ResponsiveDataTable 
                    habilitaBuscar={false} 
                    columns={columnsItem} 
                    data={dataGridItem} 
                    isIgnorar={true}
                    buttons= { disabledForm 
                        ? habilitaAvaliacao 
                            ? [
                                buttonsCorrecao,
                                {action: handleAprovarItem, label: "Aprovar", icone: "LiaCheckCircle", style: "success", regraExclude: "(row.values.status === 'Concluído' || row.values.status === 'Rejeitado')"}, 
                                {action: handleReprovarItem, label: "Reprovar", icone: "LiaTimesCircle", style: "danger", regraExclude: "(row.values.status === 'Concluído' || row.values.status === 'Rejeitado')"},
                                buttonsObservacao
                            ] 
                            : [
                                buttonsCorrecao,
                                buttonsObservacao
                            ]
                        : [
                            buttonsCorrecao,
                            {action: handleAlterarItem, label: "Alterar", icone: "MdOutlineEditNote", regraExclude: "(row.values.status === 'Concluído' || row.values.status === 'Rejeitado')"}, 
                            {action: handleExcluirItem, label: "Excluir", icone: "MdPlaylistRemove", style: "danger", regraExclude: "(row.values.status === 'Concluído' || row.values.status === 'Rejeitado')"},
                            buttonsObservacao
                        ]
                    }
                />
            )}

            <SubmitForm 
                onEnviar={tipoStatus === 'Elaboração' && !disabledForm ? handleEnviar : null} 
                onSave={disabledForm ? null : handleSalvarConfeccao} 
                onCancel={disabledForm ? null : "handleCancelar"} 
                onVoltar={disabledForm ? "handleCancelar" : null}
            ></SubmitForm>
        </>
    );
};

export default FichaGiroSSMA;
